<template>
  <div class="page">
    <!-- .page-inner -->
    <div class="page-inner container-2">
      <div class="row">
        <div class="col-12 col-lg-12 col-xl-6">
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body pb-0">
              <div class="display-flex">
                <div class="col-lg-7">
                  <div class="media mb-3">
                    <div class="user-avatar user-avatar-lg">
                      <a href="javascript:void(0);" @click="toProfile()" >
                        <img :src="this.$store.getters.photo_profile" alt="" v-if="this.$store.getters.photo_profile">
                        <div class="tile tile-circle tile-lg" :class="getRandomBg()" v-else>{{name.match(/\b(\w)/g).join("")}}</div>
                      </a>
                    </div>
                    <div class="media-body pl-3">
                      <h2 class="display-5 font-weight-light enable-responsive-font-size">Welcome,</h2>
                      <h2 class="display-5 font-weight-bold">{{name}} <img class="user-avatar mb-2" src="assets/images/wave-hand.png" alt=""/></h2>
                    </div>
                  </div>
                  <div class="media">
                    <div class="col-12">
                      <p class="card-subtitle text-muted mb-1">
                         Shortcut
                      </p>
                      <div class="col-12 pl-0 btn-toolbar">
                        <button type="button" class="btn btn-orange btn-sm mr-2 mb-1" @click="toTimeRecording()">Add Time Recording Today</button>
                        <button type="button" class="btn btn-orange btn-sm mb-1" @click="openOvertime()">Request Overtime</button>
                      </div>
                    </div>
                    <br/>
                  </div>

                </div>
                <div class="fill">
                  <img src="assets/images/mask_group.png" alt=""/>
                </div>
              </div>

            </div><!-- /.card-body -->
          </div><!-- /.card -->
        </div>
        <div class="col-12 col-lg-12 col-xl-3">
          <div class="card card-fluid ">
            <div class="blue-background pb-4">
              <p class="state-description lead">
                TO DO'S
              </p>
              <p class="mb-1">
                <span class="h2 font-weight-bold"> </span>
                <span class="h5 font-weight-light">{{task_summaries.new_approval_request || 0}} New Approval Request</span>
              </p>
              <p class="font-italic mb-3"> {{task_summaries.active_task || 0}} Active Tasks</p>
              <button type="button" class="btn btn-secondary color-blue" @click="viewTask()">View Tasks</button>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-12 col-xl-3">
          <div class="card card-fluid ">
            <div class="orange-background pb-4">
              <p class="state-description lead">
                LEAVE QUOTA
              </p>
              <p class="mb-1">
                <span class="h2 font-weight-bold">{{leave.quota}} </span>
                <span class="h5 font-weight-light">days left</span>
              </p>
              <p class="font-italic">{{leave.carried_over}} Carried Over Quota</p>
              <button type="button" class="btn btn-secondary color-orange" @click="requestAnnualLeave">Request Leave</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12 col-xl-5">
          <div class="card card-fluid">
            <div class="card-header nav-scroller">
              <!-- .nav-tabs -->
              <ul class="nav nav-tabs card-header-tabs">
                <li class="nav-item">
                  <a href="#" class="nav-link active"> <strong>WELCOME TO KOLTIVA</strong></a>
                </li>
                <li class="float-left" >
                  <div class="col-sm-12 col-md-12">
                    <div class="dataTables_filter"><span class="text-muted"></span></div>
                  </div>
                </li>
              </ul>
              <!-- /.nav-tabs -->
            </div>
            <div class="scroll-new-emp">
              <div class="card-body border-top" v-for="(item, i) in dataNewEmployee">
                <div class="media mb-0">
                  <div class="user-avatar user-avatar-xl">
                    <a href="#" class="" data-toggle="tooltip" :title="item.emp_name">
                      <img :src="item.emp_photo" alt="" v-if="item.emp_photo">
                      <div class="tile tile-circle tile-xl" style="display:block" :class="getRandomBg()" v-else>{{item.emp_name.match(/\b(\w)/g).join("")}}</div>
                    </a>
                  </div>
                  <div class="media-body pl-3">
                    <h5 class="display-5 font-weight-lighter enable-responsive-font-size ml-3 mt-3">{{item.emp_name}}</h5>
                    <p class="display-5 text-muted ml-3 mt-2"><span class="mr-2"><em class="fa fa-suitcase mr-2"></em> {{item.emp_position}} </span>
                      <span><em class="fa fa-calendar mr-2"></em> Started {{formatDate(item.start_date, 5)}} </span></p>
                  </div>
                </div>
              </div>
            </div>
            <!-- .card-body -->

          </div>
        </div>
        <div class="col-12 col-lg-12 col-xl-4">
          <div class="card card-fluid">
            <div class="card-header nav-scroller">
              <!-- .nav-tabs -->
              <ul class="nav nav-tabs card-header-tabs">
                <li class="nav-item">
                  <a href="#" class="nav-link active"> <strong>EVENT</strong></a>
                </li>
                <li class="float-left" >
                  <div class="col-sm-12 col-md-12">
                    <div class="dataTables_filter">
                      <span class="text-muted">
                        <a href="#" class="card-footer-item text-muted font-weight-light">
                          View all <em class="fa fa-fw fa-angle-right"></em>
                        </a>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="scroll-event">
              <div class="card-body border-top pb-0" v-for="(data, i) in dataEvents" v-bind:key="i">
                <div class="media mb-3 mt-1">
                  <div class="media-body">
                      <a class="font-weight-bold news-a" @click="detailEvent(data.id)">
                        <h5 class="font-weight-bold">{{data.title}}</h5>
                      </a>
                      <p class="display-5 text-muted mt-2">
                        <span class="mr-2"><em class="fa fa-calendar mr-2"></em> {{formatDate(data.start_date, 2)}} </span>
                        <span class="mr-2"><em class="fa fa-clock mr-2"></em> {{formatDate(data.start_date, 3)}} </span>
                      </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-12 col-xl-3">
          <div class="card card-fluid">
            <div class="card-header nav-scroller">
              <!-- .nav-tabs -->
              <ul class="nav nav-tabs card-header-tabs">
                <li class="nav-item">
                  <a href="#" class="nav-link active"> <strong>WHO IS OFF</strong></a>
                </li>
                <li class="float-left" >
                  <div class="col-sm-12 col-md-12">
                    <div class="dataTables_filter">
                      <span class="text-muted">{{ checkDate() }}
                        <button class="btn btn-default" type="button" @click="openDate">
                            <em class="fa fa-calendar">
                              <span aria-hidden="true" class="sr-only">Toggle</span>
                            </em>
                        </button>
                      </span>
                      <span class="text-muted">
                       <flat-pickr v-model="date_today_is_off" :config="config" ref="dateCuy"  @on-close="getDateFlatPickr" class="hide-me"></flat-pickr>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
              <!-- /.nav-tabs -->
            </div>
            <div class="scroll-whos-off">
              <div class="card-body border-top pb-0" v-for="(item, i) in dataWhoIsOff">
                <div class="media mb-0">
                  <div class="user-avatar user-avatar-lg mt-0">
                    <a href="user-profile.html" class="" data-toggle="tooltip" :title="item.emp_name">
                      <img :src="item.emp_photo" alt="" v-if="item.emp_photo">
                      <div class="tile tile-circle tile-lg" style="display:block" :class="getRandomBg()" v-else>{{item.emp_name.match(/\b(\w)/g).join("")}}</div>
                    </a>
                  </div>
                  <div class="media-body">
                    <h5 class="display-5 font-weight-lighter enable-responsive-font-size ml-2">{{item.emp_name}}</h5>
                    <p class="display-5 text-muted ml-2 mb-1"><span class="mr-2">{{item.tipe_name}}</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12 col-xl-9">
          <div class="card card-fluid">
            <div class="card-header nav-scroller">
              <!-- .nav-tabs -->
              <ul class="nav nav-tabs card-header-tabs">
                <li class="nav-item">
                  <a href="#" class="nav-link active"> <strong>TOP 10 LATEST NEWS</strong></a>
                </li>
                <li class="float-left" >
                  <div class="col-sm-12 col-md-12">
                    <div class="dataTables_filter">
                      <span class="text-muted">
                        <a href="#" class="card-footer-item text-muted">
                          View all <em class="fa fa-fw fa-angle-right"></em>
                        </a>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="card-body border-top pb-0" v-for="(data, i) in dataNews" v-bind:key="i">
                <div class="media mb-3">
                  <div class="img-thumbnail" v-if="getUrl(data.content) !== null">
                    <img :src="getUrl(data.content)" alt="" width="160" height="120px">
                  </div>
                  <div class="media-body pl-3">
                    <a class="font-weight-bold news-a" @click="detailNews(data.id)">
                      <h5 class="font-weight-bold"  ><strong>{{data.title}}</strong></h5>
                    </a>

                    <div class="card-body text-muted p-0">
                      <div v-html="data.snippet" v-if="!getUrl(data.snippet)"></div>
                    </div>
                    <p class="display-5 text-muted mt-2"><span class="mr-2">
                    <em class="fa fa-tag mr-2"></em> {{data.category_name}} </span><span class="mr-2"><em class="fa fa-clock mr-2"></em> {{formatDate(data.date, 1)}} </span>
                    </p>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div class="col-12 col-lg-12 col-xl-3">
          <div class="card card-fluid ">
            <div class="card-header nav-scroller">
              <!-- .nav-tabs -->
              <ul class="nav nav-tabs card-header-tabs">
                <li class="nav-item">
                  <a href="#" class="nav-link active"> <strong>PROJECT IN PROGRESS</strong></a>
                </li>
              </ul>
            </div>
            <div class="scroll-project">
              <div class="card-body border-top pb-0" v-for="(item, i) in dataProjects">
                <div class="media mb-0">
                  <div class="media-body">
                    <h5 class="display-5 font-weight-lighter enable-responsive-font-size">{{item.project_name}}</h5>
                    <p class="display-5 text-muted mt-2 mb-0"><span class="mr-2"><strong>Org : </strong> {{item.donor}}</span>
                    </p>
                    <p class="display-5 text-muted"><span class="mr-2"><strong>Proj : </strong> {{item.remark}}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <leave-request-input :option_leave_type="option_leave_type"  :dataEdit="null" ref="mdl"></leave-request-input>
    <compensatory-input :data="null" ref="mdl-comp"></compensatory-input>
    <overtime-input ref="mdl-ovt"></overtime-input>
  </div>
</template>

<script>

import AxiosCall from "../../libs/AxiosCall";
import FormatDate from "../../libs/FormatDate";
import {urlApi} from "../../config/url-api"
import flatPickr from 'vue-flatpickr-component';
import LeaveRequestInput from "@/components/pages/leave-request/LeaveRequestInput";
import CompensatoryInput from "./pages/compensatory/CompensatoryInput";
import OvertimeInput from "./pages/overtime/OvertimeInput";

export default {
  name: "Dashboard",
  components:{
    OvertimeInput,
    CompensatoryInput,
    LeaveRequestInput,
    flatPickr
  },
  data(){
    return {
      name:"",
      photo_profile:"",
      dataNews:[],
      dataEvents:[],
      dataProjects:[],
      dataNewEmployee:[],
      dataWhoIsOff:[],
      date_today_is_off:"",
      date_is_off:"",
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
      },
      pathDetailNews:"/detail-news/",
      option_leave_type:[],
      leave: {
        quota:0,
        expired_date:"",
        carried_over:0
      },
      compensation:{
        quota:0,
        expired_date: "",
      },
      task_summaries: {
        new_approval_task:0,
        active_task:0
      }
    }
  },
  methods:{
    toTimeRecording(){
      this.$router.push({path:"time-recording"})
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    formatDate(val, format){
      return FormatDate(val, format)
    },
    getUrl(val){

      var regex = new RegExp(/(https?:\/\/[^\s"]+)/g)
      var match = regex.exec(val)

      if (match !== null){
        return match[0]
      }
      return match
    },
    getNews(){
      this.dataEvents = []
      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id,
        "view" : "top", //top atau all
        "lang" : "en"
      }
      AxiosCall.Get(payload, urlApi.news.get).then(res=>{

        if (res.success){
          this.dataNews = res.atributes
        }else{
          this.errorMessage(res.message)
        }
      })
    },
    getEvents(){
      this.dataEvents = []
      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id,
        "view" : "top", //top atau all
        "lang" : "en"
      }
      AxiosCall.Get(payload, urlApi.events.get).then(res=>{
        if (res.success){
          this.dataEvents = res.atributes
        }else{
          this.errorMessage(res.message)
        }
      })
    },
    getProjectInProgress(){
      this.dataProjects =[]
      AxiosCall.Get({}, urlApi.project.in_progress).then(res=>{
        if (res.success){
          this.dataProjects = res.atributes
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    getNewEmployee(){
      this.dataNewEmployee = []
      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id
      }

      AxiosCall.Get(payload, urlApi.employee.new_employee).then(res=>{
        if(res.success){
          for (let data of res.atributes){
            this.dataNewEmployee.push(data)
          }

        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    getWhoIsOff(){
      this.dataWhoIsOff = []
      let payload = {}

      if(this.date_is_off !== "") payload.date = this.date_is_off

      AxiosCall.Get(payload, urlApi.employee.off).then(res=>{
        if(res.success){
          this.dataWhoIsOff = res.atributes
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    detailNews(id){
      this.$router.push({name:"DetailNews", query:{id:btoa(id)}})
    },
    detailEvent(id){
      this.$router.push({name:"DetailEvent", query:{id:btoa(id)}})
    },
    openDate(){
      this.$refs.dateCuy.fp.open()
    },
    checkDate(){
      if (this.date_today_is_off === "" || this.date_today_is_off === new Date().getFullYear()+"-"+(new Date().getMonth()+1).toString().padStart(2, '0')+"-"+new Date().getDate() ){
        return "Today"
      }
      return this.formatDate(this.date_today_is_off, 5)
    },
    getDateFlatPickr(selectedDates, dateStr, instance){
      this.date_is_off = dateStr
      this.getWhoIsOff()
    },
    getLeaveType(){
      let userProfile = this.$store.getters.userProfile
      let payload = {company_id:userProfile.data.attributes.company_id}
      AxiosCall.Get(payload, urlApi.leave_request.leave_type_list).then(res=>{
        if (res.success){
          this.option_leave_type = res.atributes
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    requestAnnualLeave(){
      this.$refs.mdl.$refs.modal.show()
    },
    getData(){

    },
    requestCompensationDay(){
      this.$refs['mdl-comp'].$refs.modal.show()
    },
    getLeaveQuota(){

          AxiosCall.Get({}, urlApi.leave_request.leave_quota).then(res=>{
            if(res.success){
              this.leave.quota = res.atributes.leave_quota || 0
              this.leave.carried_over = res.atributes.carried_over || 0
              if(res.atributes.carried_expired_date !== undefined){
                let expired_date_leave = new Date(res.atributes.carried_expired_date)
                this.leave.expired_date =expired_date_leave.toLocaleString('default', {month:'long'})+" "+expired_date_leave.getFullYear()
              }

              this.compensation.quota = res.atributes.compensatory_quota || 0
              if(res.atributes.expired_date_compensation !== undefined){
                let expired_date_compensation = new Date(res.atributes.expired_date_compensation)
                this.compensation.expired_date =expired_date_compensation.toLocaleString('default', {month:'long'})+" "+expired_date_compensation.getFullYear()
              }

            }else {
              this.$root.$children[0].errorMessage(res.message)
            }
          }).catch(e=>{
            this.$root.$children[0].errorMessage(e.response.data.message)
          })

    },
    viewTask(){
      this.$router.push({path:"notifications"});
    },
    openOvertime(){
      this.$refs['mdl-ovt'].$refs.modal.show()
    },
    getTaskSummaries(){
      AxiosCall.Get({}, urlApi.notification.task_summaries).then(res=>{
        if(res.success){
          this.task_summaries = res.atributes
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    toProfile(){
      this.$router.push({path:'/employee-edit'})
    },
    getRandomBg(){
      let bg_color = ['bg-blue','bg-indigo','bg-purple','bg-pink','bg-red','bg-orange','bg-yellow','bg-green','bg-teal','bg-cyan','bg-gray']
      const random = this.getRandomInt(0, 10);
      return bg_color[random]
    },
    getRandomInt(min, max) {
      // Create byte array and fill with 1 random number
      let byteArray = new Uint8Array(1);
      window.crypto.getRandomValues(byteArray);

      let range = max - min + 1;
      let max_range = 256;
      if (byteArray[0] >= Math.floor(max_range / range) * range)
        return this.getRandomInt(min, max);

      return min + (byteArray[0] % range);
    },
  },
  created() {
    let userProfile = this.$store.getters.userProfile
    this.name = userProfile.data.attributes.emp_name
    this.photo_profile = userProfile.data.attributes.emp_photo

    this.getNews()
    this.getEvents()
    this.getProjectInProgress()
    this.getNewEmployee()
    this.getWhoIsOff()
    this.getLeaveType()
    this.getLeaveQuota()
    this.getTaskSummaries()
  },
  mounted() {
    const flatPickerWrapperElement = this.$refs.dateCuy.getElem()

    flatPickerWrapperElement.className += ' hide-me'

  }
}
Math.rand = (function() {
  var seed = 0x2F6E2B1;
  return function() {
    // Robert Jenkins’ 32 bit integer hash function
    seed = ((seed + 0x7ED55D16) + (seed << 12))  & 0xFFFFFFFF;
    seed = ((seed ^ 0xC761C23C) ^ (seed >>> 19)) & 0xFFFFFFFF;
    seed = ((seed + 0x165667B1) + (seed << 5))   & 0xFFFFFFFF;
    seed = ((seed + 0xD3A2646C) ^ (seed << 9))   & 0xFFFFFFFF;
    seed = ((seed + 0xFD7046C5) + (seed << 3))   & 0xFFFFFFFF;
    seed = ((seed ^ 0xB55A4F09) ^ (seed >>> 16)) & 0xFFFFFFFF;
    return (seed & 0xFFFFFFF) / 0x10000000;
  };
}());
</script>

<style scoped>
.float-left{
  width:100%;
  padding:1rem;
  text-align:right
}
.active{
  border-color: #222230 !important;
  padding-bottom: 18px;
}

.nav-tabs .nav-link {
  border-width: 0 0 1px;
}
.card-header-tabs{
  font-weight: 600 !important;
}
.font-weight-bold {
  font-weight: 600 !important;
}
.scroll{
  max-height: 320px;
  overflow: scroll;
  scrollbar-width:none;
}

.scroll-project{
  max-height: 55vh;
  overflow: scroll;
  scrollbar-width:none;
}

.scroll-new-emp{
  max-height: 36vh;
  min-height: 36vh;
  overflow: scroll;
  scrollbar-width:none;
}

.scroll-event{
  max-height: 36vh;
  min-height: 36vh;
  overflow: scroll;
  scrollbar-width:none;
}

.scroll-whos-off{
  max-height: 36vh;
  min-height: 36vh;
  overflow: scroll;
  scrollbar-width:none;
}

.news-a {
  font-weight: 600 !important;
  color:#121212;
  font-size: 1.15rem;
}
.scroll::-webkit-scrollbar {
  display: none;
}

.hide-me {
  visibility: hidden !important;
  width: 0;
}
</style>